import { render, staticRenderFns } from "./RadioboxBlank.vue?vue&type=template&id=49bc56c8&"
import script from "./RadioboxBlank.vue?vue&type=script&lang=js&"
export * from "./RadioboxBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cschwan/nextcloud/workspace/server/apps-extra/activity/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49bc56c8')) {
      api.createRecord('49bc56c8', component.options)
    } else {
      api.reload('49bc56c8', component.options)
    }
    module.hot.accept("./RadioboxBlank.vue?vue&type=template&id=49bc56c8&", function () {
      api.rerender('49bc56c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/vue-material-design-icons/RadioboxBlank.vue"
export default component.exports